import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { AuthApiService } from '../../services/auth-api.service';

@Component({
  selector: 'app-esqueci-senha',
  templateUrl: './esqueci-senha.component.html',
  styleUrl: './esqueci-senha.component.scss',
  standalone: false,
})
export class EsqueciSenhaComponent implements OnInit {

  form: FormGroup;

  loading = false;
  solicitacaoEnviada = false;

  constructor(
    private fb: FormBuilder,
    private authApiService: AuthApiService,
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      login: ['', Validators.required],
    });
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.loading = true;

    const { login } = this.form.value;

    // Sempre mostra a mesma confirmação, exista o login ou não, para não permitir
    // que alguém descubra logins válidos testando o formulário.
    this.authApiService.esqueciSenha(login!).subscribe({
      next: () => this.finalizarSolicitacao(),
      error: () => this.finalizarSolicitacao(),
    });
  }

  isInvalid(campo: string): boolean {
    const control = this.form.get(campo);
    return !!control && control.invalid && control.touched;
  }

  private finalizarSolicitacao(): void {
    this.solicitacaoEnviada = true;
    this.loading = false;
  }
}
